import { useGetCustomerPortalUrl } from '@legacy/apis/indexAPI';
import { useTranslation } from 'react-i18next';
import { useGetShowSignUpButton } from '@legacy/apis/userSettingsAPI';
import { MenuItem, Stack } from '@mui/material';
import { OpenInNew } from '@mui/icons-material';

export const CustomerPortalButton = () => {
  const { customerPortalUrl, isSuccess: isSuccessCustomerPortalUrl } =
    useGetCustomerPortalUrl();
  const { showSignUpButton, isSuccess: isSuccessShowSignUpButton } =
    useGetShowSignUpButton();
  const { t } = useTranslation('header');

  if (!customerPortalUrl || showSignUpButton) {
    return null;
  }

  return isSuccessCustomerPortalUrl && isSuccessShowSignUpButton ? (
    <MenuItem
      component="a"
      data-automation-id="HeaderCustomerPortalButton"
      target="_blank"
      rel="noopener"
      href={customerPortalUrl}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        {t('UserMenuMyTimeLogAccountLink')}
        <OpenInNew fontSize="small" />
      </Stack>
    </MenuItem>
  ) : null;
};
